// Modules
import React from 'react';

// Components
import { Checkout } from '@pages/checkout';
import { OrderConfirmation } from '@pages/orderConfirmation';
import { Subscription } from '@pages/SubscriptionDetails';
import { Page404 } from '@pages/404';

// Utils
import * as Constants from '@global/App/constants/constants';
import { localizeRoutes } from '@global/localization/services';

export const mainRoutes: (isNonLocalizedSite: boolean) => Array<{
  path: string;
  component?: React.FC;
  localize?: boolean;
}> = (isNonLocalizedSite) =>
  localizeRoutes([
    {
      path: Constants.Pages.CHECKOUT,
      component: Checkout,
      localize: !isNonLocalizedSite,
    },
    { path: Constants.Pages.ERR404, component: Page404 },
  ]);

export const protectedRoutes: (isNonLocalizedSite: boolean) => Array<{
  path: string;
  component?: React.FC;
  localize?: boolean;
}> = (isNonLocalizedSite) =>
  localizeRoutes([
    {
      path: Constants.Pages.ORDER_CONFIRMATION,
      component: OrderConfirmation,
      localize: !isNonLocalizedSite,
    },
    {
      path: Constants.Pages.SUBSCRIPTION_DETAILS,
      component: Subscription,
      localize: !isNonLocalizedSite,
    },
  ]);
